import React from 'react';
import Navbar from '../Navbar/Navbar';
import HeaderMain from './HeaderMain/HeaderMain';

const Header = () => {
    return (
        <div className="bg-light">
        <Navbar></Navbar>
        <HeaderMain />
        </div>
    );
};

export default Header;